"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _colors = require("@material-ui/core/colors");

var _accent = _interopRequireDefault(require("./accent"));

var error = {
  contrastText: _colors.common.white,
  dark: _accent["default"].redDark,
  light: _accent["default"].redLight,
  main: _accent["default"].redMain
};
var _default = error;
exports["default"] = _default;